<template>
  <div class="buy-card-modal">
    <div
      class="buy-card-modal__backdrop"
      ref="backdrop"
      @click.once="toggle()"
    ></div>

    <div
      class="buy-card-modal__inner pt-89 pl-55 pr-55 flex column"
      ref="modal_inner"
    >
      <div class="buy-card-modal__x-btn pointer" @click.once="toggle()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22.121"
          height="22.121"
          viewBox="0 0 22.121 22.121"
        >
          <g
            id="CLOSE_копия"
            data-name="CLOSE копия"
            transform="translate(1.061 1.061)"
          >
            <line
              id="Фигура_562"
              data-name="Фигура 562"
              x2="20"
              y2="20"
              fill="none"
              stroke="#4d4d4f"
              stroke-width="3"
            />
            <line
              id="Фигура_562_копия"
              data-name="Фигура 562 копия"
              x1="20"
              y2="20"
              fill="none"
              stroke="#4d4d4f"
              stroke-width="3"
            />
          </g>
        </svg>
      </div>
      <div class="flex column" v-if="not_passed">
        <h2 class="f-34 regular uppercase mb-34">
          {{ $fn.tr("ბარათის შეძენა") }}
        </h2>
        <h3 class="f-14 bold mb-21" style="color: #4D4D4F">
          {{ $fn.tr("ბარათის შეძენის მოდალის თიზერი") }}
        </h3>
        <p class="f-14 bold mb-55">
          <span style="color: #E50B09">*</span>&nbsp;{{
            $fn.tr("ბარათის შეძენის გამაფრთხილებელი ნოუთი")
          }}
        </p>

        <input
          type="text"
          @input="check_digits_phone($event)"
          ref="phone_field"
          :placeholder="$fn.tr('მობილურის ნომერი')"
          class="mb-30"
        />
        <input
          type="text"
          @input="set_name_field($event)"
          ref="name_field"
          :placeholder="$fn.tr('სახელი და გვარი')"
          class="mb-30"
        />
        <span class="f-14 bold mb-13">{{ $fn.tr("შეკვეთის დეტალები") }}</span>
        <textarea
          type="textarea"
          ref="text_field"
          :placeholder="
            $fn.tr('ბარათის შეძენის მოდალის ტექსტის ველის ფლეისჰოლდერი')
          "
          class="mb-30"
          style="resize: none;"
          v-model="orderDetails"
        />

        <div class="buy-card-modal__radio-wrapper flex column mb-55">
          <div class="flex mb-13 al-center">
            <el-radio v-model="service" label="1">{{
              $fn.tr("სითიმოლიდან გატანა")
            }}</el-radio>
          </div>
          <div class="flex al-center">
            <el-radio v-model="service" label="2">{{
              $fn.tr("საკურიერო მომსახურება")
            }}</el-radio>
          </div>
        </div>

        <button
          class="buy-card-modal__button flex al-center f-white pangram-extrabold pointer"
          :class="
            !orderDetails.length ||
            !phone_field.toString().length ||
            !name_field.length
              ? 'disabled-button'
              : ''
          "
          @click.prevent="order($event)"
        >
          {{ $fn.tr("შეუკვეთე") }}
        </button>
      </div>

      <div class="flex column al-center pt-144" v-if="!not_passed & success">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="90"
          height="90"
          viewBox="0 0 90 90"
        >
          <g
            id="Group_8608"
            data-name="Group 8608"
            transform="translate(-912 -398)"
          >
            <circle
              id="Ellipse_444"
              data-name="Ellipse 444"
              cx="45"
              cy="45"
              r="45"
              transform="translate(912 398)"
              fill="#28ad25"
            />
            <g id="fi-br-check" transform="translate(943 362.428)">
              <path
                id="Path_8819"
                data-name="Path 8819"
                d="M8.946,90.573a2.96,2.96,0,0,1-2.1-.869L.511,83.369a1.747,1.747,0,1,1,2.47-2.47l5.964,5.964L24.724,71.084a1.747,1.747,0,1,1,2.47,2.47L11.042,89.7a2.96,2.96,0,0,1-2.1.869Z"
                transform="translate(0 0)"
                fill="#fff"
              />
            </g>
          </g>
        </svg>

        <h2
          class="f-34 bold mt-34 mb-21 pangram-extrabold"
          style="text-align: center;"
        >
          {{ $fn.tr("შეკვეთა წარმატებით დასრულდა") }}
        </h2>
        <p class="f-14 bold mb-34" style="text-align: center;">
          {{
            $fn.tr(
              "დამატებითი დეტალებისათვის დაგიკავშირდებით სატელეფონო ცენტრიდან 0322 555 222"
            )
          }}
        </p>
        <div
          class="buy-card-modal__button f-white pangram-extrabold flex al-center pointer"
          @click="toggle()"
        >
          {{ $fn.tr("დახერვა") }}
        </div>
      </div>

      <div class="flex column al-center pt-144" v-if="!not_passed & fail">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="90"
          height="90"
          viewBox="0 0 90 90"
        >
          <g
            id="Group_9799"
            data-name="Group 9799"
            transform="translate(-1511.408 -233)"
          >
            <circle
              id="Ellipse_444"
              data-name="Ellipse 444"
              cx="45"
              cy="45"
              r="45"
              transform="translate(1511.408 233)"
              fill="#e50b09"
            />
            <g
              id="fi-br-plus"
              transform="translate(1535.408 278.001) rotate(-45)"
            >
              <path
                id="Path_8834"
                data-name="Path 8834"
                d="M28.125,13.125H16.875V1.875a1.875,1.875,0,0,0-3.75,0v11.25H1.875a1.875,1.875,0,0,0,0,3.75h11.25v11.25a1.875,1.875,0,0,0,3.75,0V16.875h11.25a1.875,1.875,0,0,0,0-3.75Z"
                fill="#fff"
              />
            </g>
          </g>
        </svg>

        <h2
          class="f-34 bold mt-34 mb-21 pangram-extrabold"
          style="text-align: center;"
        >
          {{ $fn.tr("დაფიქსირდა შეცდომა") }}
        </h2>

        <div
          class="buy-card-modal__reset underline pangram-extrabold pointer"
          @click="reset_modal()"
        >
          {{ $fn.tr("სცადე თავიდან") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getCardData from "../../mixins/getCardData";
export default {
  mixins: [getCardData],
  data() {
    return {
      phone_field: "",
      name_field: "",
      service: "1",
      orderDetails: "",
      //
      not_passed: true,
      success: false,
      fail: false
    };
  },

  methods: {
    toggle() {
      let _timeout, TIMEOUT;
      this.$refs.modal_inner.classList.remove("active");

      TIMEOUT = setTimeout(() => {
        this.$refs.backdrop.classList.remove("active");
        clearTimeout(TIMEOUT);
      }, 500);
      _timeout = setTimeout(() => {
        this.$store.commit("main/setState", {
          key: "buy_card_modal",
          val: false
        });
        clearTimeout(_timeout);
      }, 921);
    },

    check_digits_phone(e) {
      e.preventDefault();
      let val = e.target.value;

      if (val && !isNaN(val)) {
        this.phone_field = parseInt(val);
      } else if (val.length === 0) {
        this.phone_field = "";
      } else {
        e.target.value = this.phone_field;
      }
    },

    set_name_field(e) {
      e.preventDefault();
      if (isNaN(parseInt(e.data))) {
        this.name_field = e.target.value;
        e.target.value = this.name_field;
      } else {
        e.target.value = this.name_field;
      }
    },

    async order() {

      const res = await this.orderGiftCard(
        this.name_field,
        this.phone_field.toString(),
        this.orderDetails,
        Number(this.service),
        "loremipsum"
      );
      if (res.data.success) {
        this.fail = false;
        this.not_passed = false;
        this.success = true;
      } else {
        this.fail = true;
        this.not_passed = false;
        this.success = false;
      }
    },

    reset_modal() {
      this.fail = false;
      this.not_passed = true;
    }
  },
  watch: {
    toggler: {
      immediate: true,
      handler(ns) {
        console.log(ns);
        let _timeout, TIMEOUT;
        if (ns == true) {
          _timeout = setTimeout(() => {
            this.$refs.backdrop.classList.add("active");
            clearTimeout(_timeout);
          }, 200);
          TIMEOUT = setTimeout(() => {
            this.$refs.modal_inner.classList.add("active");
            clearTimeout(TIMEOUT);
          }, 400);

          document.body.classList.add("ov_hidden");
          document.getElementsByTagName("html")[0].removeAttribute("style");
        } else {
          document.body.classList.remove("ov_hidden");
        }
      }
    }
  },
  computed: {
    toggler() {
      return this.$store.state.main.buy_card_modal;
    }
  }
};
</script>

<style lang="scss">
.buy-card-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999999999;
  .disabled-button {
    pointer-events: none;
    opacity: 0.5;
  }
  &__backdrop {
    transition: 0.4s;
    @include modal_bg(#1a1a1a, 3);
    opacity: 0;
    &.active {
      opacity: 0.5;
    }
  }
  &__x-btn {
    position: absolute;
    top: 30px;
    right: 30px;
    width: 23px;
    height: 23px;
    z-index: 5;
    svg path {
      transition: 0.4s;
    }
    @include hover {
      svg path {
        fill: $red;
      }
    }
  }
  &__inner {
    position: absolute;
    top: 0;
    right: 0;
    transform: translateX(100%);
    background-color: white;
    z-index: 4;
    width: 727px;
    transition: 0.6s;
    height: 100%;
    padding-bottom: 55px;
    &.active {
      transform: translateX(0);
    }
    overflow-y: auto;
  }
  &__button {
    background-color: #4d4d4f;
    transition: 0.4s;
    width: fit-content;
    height: 60px;
    padding-left: 82px;
    padding-right: 82px;
    @include hover {
      background-color: black;
    }
  }
  &__reset {
    color: #4d4d4f;

    transition: 0.4s;
    @include hover {
      color: black;
    }
  }

  input,
  textarea {
    height: 60px;
    border-radius: 0px;
    border: 2px solid #c9c9ca;
    font-size: 13px;
    line-height: 24px;
    font-family: "Hm-Pangram-bold";
    padding: 20px;
    color: #4d4d4f;
    transition: 0.4s;

    border-color: #c9c9ca;
    &::placeholder {
      color: rgba(96, 98, 102, 0.8);
    }
    &:focus {
      border-color: black;
    }
  }

  .el-radio,
  .el-radio span {
    color: rgba(96, 98, 102, 0.8);
    font-family: "Hm-Pangram-bold";
  }
  .el-radio__inner {
    width: 20px;
    height: 20px;
    transition: 0.4s;
    &:hover {
      border-color: #ffcb05;
    }
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #4d4d4f;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #ffcb05;
    border-width: 2px;
    background: white;

    &:after {
      background-color: #ffcb05;
      width: 10px;
      height: 10px;
    }
  }

  textarea {
    height: 120px;
  }
  input[type="radio"] {
    -webkit-appearance: radio;
  }

  @media (max-width: 1200px) {
    &__inner {
      padding-top: 55px;
      padding-left: 30px;
      padding-right: 30px;

      .mb-34 {
        margin-bottom: 21px;
      }
      .mb-55 {
        margin-bottom: 34px;
      }
      .mb-30 {
        margin-bottom: 21px;
      }
    }
  }
  @media (max-width: 767px) {
    .pt-144 {
      padding-top: 55px;
    }
    &__inner {
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      padding-left: 21px;
      padding-right: 21px;
      padding-top: 34px;
      padding-bottom: 34px;
      .mb-55 {
        margin-bottom: 21px;
      }
      .f-34 {
        font-size: 21px;
      }
    }
    &__button {
      height: 40px;
      padding-left: 55px;
      padding-right: 55px;
    }
    input {
      height: 40px;
    }
  }
}
</style>
